import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/with-selector';
export function useReactiveVarWithSelector(rv, selector, isEqual) {
  const value = useSyncExternalStoreWithSelector(onStoreChange => {
    let unsubscribe;
    const listener = () => {
      onStoreChange();
      unsubscribe = rv.onNextChange(listener);
    };
    unsubscribe = rv.onNextChange(listener);
    return () => unsubscribe();
  }, rv, rv, selector, isEqual);
  return value;
}